import { useContext } from 'react';

import { Context } from '../Store';
import { ActionTypes } from '../Store.d';

/**
 * Asks the use if they want to insert a voucher code.
 *
 * @returns {React.ReactNode | null}
 */
function VoucherPrompt() {
	const [, dispatch] = useContext(Context);

	return (
		<p>
			Sie haben einen{' '}
			<button
				className="link"
				onClick={() =>
					dispatch({
						type: ActionTypes.toggleVoucherInput,
						payload: true
					})
				}
				type="button"
			>
				Gutschein
			</button>
			?
		</p>
	);
}

export { VoucherPrompt };
